var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selectedJobPosting !== undefined
    ? _c(
        "div",
        {
          staticClass: "job-details-view",
          style: { height: _vm.windowHeight - 70 + "px" },
        },
        [
          _c("div", { staticClass: "job-details-top sticky-top" }, [
            _c(
              "div",
              { staticClass: "sticky-top-container d-flex px-4 py-2" },
              [
                _vm.isMobile
                  ? _c(
                      "p",
                      {
                        staticClass: "text-brand-medium clickable",
                        on: {
                          click: function ($event) {
                            return _vm.closeDetailView()
                          },
                        },
                      },
                      [
                        _c("b-icon", {
                          staticClass: "mr-1",
                          attrs: { scale: "1.3", icon: "chevron-left" },
                        }),
                        _vm._v(_vm._s(_vm.t.general_Back)),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.selectedJobPosting.ListOfLinks.length < 1 || _vm.isMobile
                  ? [
                      _vm.isMobile === false
                        ? _c(
                            "b-button",
                            {
                              staticClass: "rounded",
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.goToPage(
                                    _vm.selectedJobPosting.Url
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.t.jobSearch_V2_Go_To_Job))]
                          )
                        : _vm._e(),
                    ]
                  : [
                      _c(
                        "b-dropdown",
                        {
                          staticClass: "rounded rounded",
                          attrs: {
                            split: "",
                            variant: "primary",
                            text: _vm.t.jobSearch_V2_Go_To_Job,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.goToPage(_vm.selectedJobPosting.Url)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "text-brand-medium pb-1 pl-4" },
                            [_vm._v(_vm._s(_vm.t.jobSearch_V2_See_Job_At))]
                          ),
                          _c("b-dropdown-divider"),
                          _c(
                            "b-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.goToPage(
                                    _vm.selectedJobPosting.Url
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.formatUrlString(
                                    _vm.selectedJobPosting.Url
                                  )
                                )
                              ),
                            ]
                          ),
                          _vm._l(
                            _vm.selectedJobPosting.ListOfLinks,
                            function (link, index) {
                              return _vm.formatUrlString(link) !==
                                _vm.formatUrlString(_vm.selectedJobPosting.Url)
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      key: index,
                                      on: {
                                        click: function ($event) {
                                          return _vm.goToPage(link)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.formatUrlString(link)))]
                                  )
                                : _vm._e()
                            }
                          ),
                        ],
                        2
                      ),
                    ],
                _vm.jobmatch === true &&
                _vm.isMobile === false &&
                _vm.content.navigateToJobApplication &&
                _vm.jobApplicationAccess === true
                  ? _c(
                      "b-button",
                      {
                        staticClass: "rounded ml-2",
                        attrs: { variant: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.goToJobApplication(
                              _vm.selectedJobPosting.JobId
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.t.jobmatch_Go_To_Job_Application))]
                    )
                  : _vm._e(),
              ],
              2
            ),
            _vm.selectedJobPosting.Date
              ? _c(
                  "div",
                  {
                    staticClass:
                      "sticky-top-container d-flex justify-content-end px-4 py-2 text-brand-medium text-capitalize d-flex align-items-end",
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.t.jobSearch_V2_Posted) +
                        ": " +
                        _vm._s(_vm.formatDate(_vm.selectedJobPosting.Date))
                    ),
                  ]
                )
              : _vm._e(),
            _c("hr"),
          ]),
          _c(
            "div",
            { staticClass: "p-4 pt-0" },
            [
              _c("div", { staticClass: "d-flex justify-content-between" }, [
                _c("h4", { staticClass: "d-flex align-items-center" }, [
                  _vm._v(_vm._s(_vm.selectedJobPosting.Jobtitle)),
                ]),
                _vm.useSavedAdvert === true && _vm.isMobile === false
                  ? _c(
                      "div",
                      { staticClass: "col-1 p-0" },
                      [
                        _c("HeartEmptyFull", {
                          attrs: {
                            isFull: _vm.selectedJobPosting.IsSavedAdvert,
                          },
                          on: {
                            heartClicked: function ($event) {
                              return _vm.toggleSavedAdvert(
                                _vm.selectedJobPosting
                              )
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.useSavedAdvert === true && _vm.isMobile === true
                  ? _c(
                      "div",
                      { staticClass: "col-1 text-right p-0" },
                      [
                        _c("HeartEmptyFull", {
                          attrs: {
                            isFull: _vm.selectedJobPosting.IsSavedAdvert,
                          },
                          on: {
                            heartClicked: function ($event) {
                              return _vm.toggleSavedAdvert(
                                _vm.selectedJobPosting
                              )
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "text-grey" }, [
                _vm._v(_vm._s(_vm.selectedJobPosting.Company.Name)),
              ]),
              _vm.selectedJobPosting.Location != "" &&
              _vm.selectedJobPosting.Location != null &&
              !_vm.selectedJobPosting.Company.Address.City.includes(
                _vm.selectedJobPosting.Location
              )
                ? _c("div", { staticClass: "text-grey" }, [
                    _vm._v(_vm._s(_vm.selectedJobPosting.Location)),
                  ])
                : _c("div", { staticClass: "text-grey" }, [
                    _vm._v(
                      _vm._s(
                        _vm.selectedJobPosting.Company.Address.PostalCode
                      ) +
                        " " +
                        _vm._s(_vm.selectedJobPosting.Company.Address.City)
                    ),
                  ]),
              _c("div", {
                staticClass: "result-item-text mt-4",
                domProps: { innerHTML: _vm._s(_vm.selectedJobPosting.Text) },
              }),
              _vm.selectedJobPosting.Occupations
                ? _c("JobDetailsViewDebugInfo", {
                    attrs: { jobPosting: _vm.selectedJobPosting },
                  })
                : _vm._e(),
              _vm.isMobile ? _c("div", { staticClass: "py-4" }) : _vm._e(),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }